const flagFeatureOn = (environment) => {
  const appEnvironment = process.env.NODE_ENV;
  return appEnvironment !== environment;
};

const STAGING = 'staging';
const DEVELOPMENT = 'development';
const PRODUCTION = 'production';

const FLAGS = {
  ONBOARDING_V2: 'basqet_onboarding_v2',
  MERCHANT_OIDC: 'enable_basqet_merchant_oidc'
};

const IN_HOUSE_FLAGS = {
  NAIRA_COLLECTIONS: 'naira_collections',
  NGN_VIRTUAL_ACCOUNT: 'ngn_virtual_account'
};

export { DEVELOPMENT, flagFeatureOn, FLAGS, IN_HOUSE_FLAGS, PRODUCTION, STAGING };
